import { useEffect, useState } from "react";

/**
 * Whether the browser thinks it can reach the network.
 *
 * The page reads with it and writes without it: a payment that cannot leave is not offered and
 * then failed, it is not offered (checkout 1.4 `data.offline`).
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() =>
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return online;
}
